import { IClaimManagementType } from 'context/ClaimManagement';
import api, { slotConfig } from 'utils/api';

export const ClaimSearchService = {
    getSearchWithResponse: (skip?: number, take?: number): any => {
        const params = new URLSearchParams();
        if (skip !== undefined) params.append('skip', skip.toString());
        if (take !== undefined) params.append('take', take.toString());
        const url = `${process.env.REACT_APP_CLAIM_SEARCH_API_URL}${params.toString() ? '?' + params.toString() : ''}`;
        return api.get(url, slotConfig);
    }
};
export const UpdateClaimsBatchService = {
    postClaimWithResponse: (body: IClaimManagementType[]): any => {
        return api.put(`${process.env.REACT_APP_CLAIMS_UPDATE_BATCH}`, body, slotConfig);
    }
};
